/**
 *   This is a service for a specific store module.
 *   We separate our files for easy managment and readibility.
 *   We export this as a service to be used in other areas of the application.
 */

import Api from '@/services/api';
import Store from '@/store/index';

export default {

  async logSupportDebug(message: string) {
    if ('NO' === process.env.VUE_APP_ISLIVE) {
      // tslint:disable-next-line:no-console
      console.log(`${new Date().toISOString().split('.')[0].replace('T', ' ')} - ` + message);
    }
  },

  async errorHandler(message: string, timeout?: number) {
    Store.dispatch('app/snackbar', {
      show: true,
      text: message,
      color: 'error',
      icon: Store.getters['app/icons'].error,
      timeout: timeout ? timeout : Number(process.env.VUE_APP_SNACKBAR_TIMEOUT),
    });
  },

  async warningHandler(message: string, timeout?: number) {
    Store.dispatch('app/snackbar', {
      show: true,
      text: message,
      color: 'warning',
      icon: Store.state.app.icons.warning,
      timeout: timeout ? timeout : Number(process.env.VUE_APP_SNACKBAR_TIMEOUT),
    });
  },

  async successHandler(message: string, timeout?: number) {
    Store.dispatch('app/snackbar', {
      show: true,
      text: message,
      color: 'success',
      icon: Store.getters['app/icons'].success,
      timeout: timeout ? timeout : Number(process.env.VUE_APP_SNACKBAR_TIMEOUT),
    });
  },

  async listStatuses(refreshFromAPI: boolean) {
    // check if we need to force an API refresh or have already fetched this data and it is in the Store
    if (refreshFromAPI || Store.getters['app/statuses'].length < 1) {
      try {
        const response = await Api(true).get('/app/list_statuses');
        
        if (response && response.data) {
          if (response.data.result && response.data.result === 'false') {
            Store.dispatch('app/setStatuses', {
              statuses: [],
            });
            return response.data.message;
          } else {
            Store.dispatch('app/setStatuses', {
              statuses: response.data,
            });
            return '';
          }
        } else {
          // response is undefined or has no data field - SHOULD NEVER HAPPEN!
          throw new Error('response: ' + JSON.stringify(response));
        }

      } catch (error) {
        Store.dispatch('app/setStatuses', {
          statuses: [],
        });
        if (error.response) {
          return error.response.statusText;
        } else {
          await this.logSupportDebug('app.ts - listStatuses - 79 - ' + error);
          return Store.getters['app/messages'].couldNotConnect;
        }
      } 
    } else {
      // this data is ready to access in the Store
      return '';
    }
  },
};
